import * as React from 'react';
import StatusCompleteFilledSmall from 'wix-ui-icons-common/StatusCompleteFilledSmall';
import style from './solution-badge.scss';
import PremiumSmall from 'wix-ui-icons-common/PremiumSmall';
import StatusWarningFilledSmall from 'wix-ui-icons-common/StatusWarningFilledSmall';
import { Box, Popover, Text } from 'wix-style-react';
import { composer } from '../../component-decorators/composer';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import { getLowestPrice, getPricingLabel } from "../common";
export var SolutionBadge = composer()
    .withExperiments()
    .compose(function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var t = _a.t, isInstalled = _a.isInstalled, showPremiumLabel = _a.showPremiumLabel, pricing = _a.pricing, isBundleAppInstalled = _a.isBundleAppInstalled, isBundleAppNotInstalled = _a.isBundleAppNotInstalled, savedPrice = _a.savedPrice, isAppSetupIncomplete = _a.isAppSetupIncomplete, shouldShowIncompleteSetupPopover = _a.shouldShowIncompleteSetupPopover, experiments = _a.experiments, companyId = _a.companyId;
    var shouldShowInNewOrder = experiments.enabled('specs.marketplace.complete-setup');
    var shouldShowFullPrices = experiments.enabled('specs.marketplace.fullPrices');
    // tslint:disable:react-hooks-nesting
    var _o = React.useState(false), isPopoverShown = _o[0], setIsPopoverShown = _o[1];
    var _p = React.useState(false), seeFullPrices = _p[0], setSeeFullPrices = _p[1];
    React.useEffect(function () {
        var _a, _b, _c;
        if (shouldShowFullPrices && !pricing.isExternalPricing && (pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'PREMIUM' && (pricing === null || pricing === void 0 ? void 0 : pricing.freeTrialDays) <= 0
            && ((_c = (_b = (_a = pricing === null || pricing === void 0 ? void 0 : pricing.plans) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.premiumPrices) === null || _c === void 0 ? void 0 : _c.fullPrices)) {
            setSeeFullPrices(true);
        }
    }, [(_e = (_d = (_c = pricing === null || pricing === void 0 ? void 0 : pricing.plans) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.premiumPrices) === null || _e === void 0 ? void 0 : _e.fullPrices]);
    var priceLabel = getPricingLabel(pricing, shouldShowFullPrices, companyId);
    var currencyToString = usePremiumCurrencyFormatter({
        currencySettings: (_b = {},
            _b[(_f = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _f === void 0 ? void 0 : _f.code] = {
                symbol: (_g = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _g === void 0 ? void 0 : _g.symbol,
                decimalSep: (_h = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _h === void 0 ? void 0 : _h.decimalSeparator,
                groupSep: (_j = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _j === void 0 ? void 0 : _j.groupSeparator,
                negPrefix: (_k = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _k === void 0 ? void 0 : _k.negativePrefix,
                negSuffix: (_l = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _l === void 0 ? void 0 : _l.negativeSuffix,
                posPrefix: '¤',
                posSuffix: '',
                fractionSize: 2,
            },
            _b),
        currencyCode: (_m = pricing === null || pricing === void 0 ? void 0 : pricing.currencySettings) === null || _m === void 0 ? void 0 : _m.code,
    })[0];
    var fixedPrice = savedPrice !== undefined && savedPrice !== 0 ? Number(savedPrice).toFixed(2) : '';
    var fixedPriceWithTaxAndCurrency = shouldShowFullPrices ?
        currencyToString(Number(fixedPrice)) : "$" + fixedPrice;
    if (shouldShowInNewOrder) {
        if (isBundleAppNotInstalled) {
            return (React.createElement("span", { className: style.flexView },
                fixedPrice !== '' && (React.createElement("span", { style: { textDecoration: 'line-through' } },
                    React.createElement(Text, { size: "tiny", weight: "thin" }, fixedPriceWithTaxAndCurrency))),
                React.createElement("span", { style: { marginLeft: '6px' } },
                    React.createElement(Text, { size: "tiny", weight: "thin", skin: "success" }, t('solutionBox.solutionBottomActionBar.BundleNotInstalled')))));
        }
        if (isBundleAppInstalled) {
            return (React.createElement("span", { className: style.bundleBadge },
                React.createElement(StatusCompleteFilledSmall, { className: style.installedIcon }),
                React.createElement(Text, { size: "tiny", weight: "thin", skin: "success", dataHook: "installed-text" }, t('solutionBox.solutionBottomActionBar.BundleInstalled'))));
        }
        if (showPremiumLabel) {
            return (React.createElement("div", { className: style.premiumBadge },
                React.createElement(PremiumSmall, null),
                React.createElement(Text, { size: "tiny", weight: "thin", skin: "standard", secondary: true, className: style.premiumText }, t('app.pricing.Premium'))));
        }
        if (isAppSetupIncomplete) {
            return (React.createElement(Popover, { showArrow: true, appendTo: "window", placement: "right", theme: "dark", shown: isPopoverShown, onMouseEnter: function () {
                    if (shouldShowIncompleteSetupPopover) {
                        setIsPopoverShown(true);
                    }
                }, onMouseLeave: function () {
                    if (shouldShowIncompleteSetupPopover) {
                        setIsPopoverShown(false);
                    }
                } },
                React.createElement(Popover.Element, null,
                    React.createElement(Box, { verticalAlign: "middle" },
                        React.createElement(StatusWarningFilledSmall, { color: "#fdb10c" }),
                        React.createElement(Box, { marginLeft: "4px" },
                            React.createElement(Text, { skin: "standard", secondary: true, weight: "thin", size: "tiny" }, t('solutionBox.solutionBottomActionBar.IncompleteSetup'))))),
                React.createElement(Popover.Content, null,
                    React.createElement(Box, { padding: "12px 24px", maxWidth: "102px" },
                        React.createElement(Text, { skin: "standard", light: true, weight: "thin", size: "small" }, t('solutionBox.solutionBottomActionBar.IncompleteSetupTooltip'))))));
        }
        if (isInstalled) {
            return (React.createElement("span", { className: style.centeredView },
                React.createElement(StatusCompleteFilledSmall, { className: style.installedIcon }),
                React.createElement(Text, { size: "tiny", weight: "thin", skin: "success", dataHook: "installed-text" }, t('solutionBox.solutionBottomActionBar.installedSolution'))));
        }
        return (React.createElement(Text, { size: "tiny", weight: "thin", skin: "standard", secondary: true, dataHook: "business-model-text", className: style.centeredView }, t(priceLabel, {
            trialDays: pricing === null || pricing === void 0 ? void 0 : pricing.freeTrialDays,
            price: pricing.lowestMonthlyPrice,
            fullPrice: seeFullPrices ? currencyToString(getLowestPrice(pricing)) : ''
        })));
    }
    if (isBundleAppNotInstalled) {
        return (React.createElement("span", { className: style.flexView },
            fixedPrice !== '' && (React.createElement("span", { style: { textDecoration: 'line-through' } },
                React.createElement(Text, { size: "tiny", weight: "thin" }, fixedPriceWithTaxAndCurrency))),
            React.createElement("span", { style: { marginLeft: '6px' } },
                React.createElement(Text, { size: "tiny", weight: "thin", skin: "success" }, t('solutionBox.solutionBottomActionBar.BundleNotInstalled')))));
    }
    if (isBundleAppInstalled) {
        return (React.createElement("span", { className: style.bundleBadge },
            React.createElement(StatusCompleteFilledSmall, { className: style.installedIcon }),
            React.createElement(Text, { size: "tiny", weight: "thin", skin: "success", dataHook: "installed-text" }, t('solutionBox.solutionBottomActionBar.BundleInstalled'))));
    }
    if (isInstalled) {
        return (React.createElement("span", { className: style.centeredView },
            React.createElement(StatusCompleteFilledSmall, { className: style.installedIcon }),
            React.createElement(Text, { size: "tiny", weight: "thin", skin: "success", dataHook: "installed-text" }, t('solutionBox.solutionBottomActionBar.installedSolution'))));
    }
    if (showPremiumLabel) {
        return (React.createElement("div", { className: style.premiumBadge },
            React.createElement(PremiumSmall, null),
            React.createElement(Text, { size: "tiny", weight: "thin", skin: "standard", secondary: true, className: style.premiumText }, t('app.pricing.Premium'))));
    }
    return (React.createElement(Text, { size: "tiny", weight: "thin", skin: "standard", secondary: true, dataHook: "business-model-text", className: style.centeredView }, t(priceLabel, {
        trialDays: pricing === null || pricing === void 0 ? void 0 : pricing.freeTrialDays,
        price: pricing.lowestMonthlyPrice,
        fullPrice: seeFullPrices ? currencyToString(getLowestPrice(pricing)) : ''
    })));
});
//# sourceMappingURL=solution-badge.js.map